export const REQUEST_MACHINE_VNC_SESSION_REQUEST =
  'REQUEST_MACHINE_VNC_SESSION_REQUEST';
export const REQUEST_MACHINE_VNC_SESSION_SUCCESS =
  'REQUEST_MACHINE_VNC_SESSION_SUCCESS';
export const REQUEST_MACHINE_VNC_SESSION_FAIL =
  'REQUEST_MACHINE_VNC_SESSION_FAIL';
export const REQUEST_MACHINE_VNC_SESSION_RESET_STATE =
  'REQUEST_MACHINE_VNC_SESSION_RESET_STATE';

export const GET_MACHINE_VNC_SESSION_STATUS_REQUEST =
  'GET_MACHINE_VNC_SESSION_STATUS_REQUEST';
export const GET_MACHINE_VNC_SESSION_STATUS_SUCCESS =
  'GET_MACHINE_VNC_SESSION_STATUS_SUCCESS';
export const GET_MACHINE_VNC_SESSION_STATUS_FAIL =
  'GET_MACHINE_VNC_SESSION_STATUS_FAIL';
export const SAVE_MACHINE_VNC_SESSION_STATUS_RESPONSE =
  'SAVE_MACHINE_VNC_SESSION_STATUS_RESPONSE';
export const GET_MACHINE_VNC_SESSION_STATUS_RESET_STATE =
  'GET_MACHINE_VNC_SESSION_STATUS_RESET_STATE';

export const SHOW_MACHINE_VNC_SESSION_STATUS_MODAL =
  'SHOW_MACHINE_VNC_SESSION_STATUS_MODAL';
export const HIDE_MACHINE_VNC_SESSION_STATUS_MODAL =
  'HIDE_MACHINE_VNC_SESSION_STATUS_MODAL';

export const SHOW_MACHINE_VNC_SESSION_FIRMWARE_CHECKING_MODAL =
  'SHOW_MACHINE_VNC_SESSION_FIRMWARE_CHECKING_MODAL';
export const HIDE_MACHINE_VNC_SESSION_FIRMWARE_CHECKING_MODAL =
  'HIDE_MACHINE_VNC_SESSION_FIRMWARE_CHECKING_MODAL';

export const CHECK_MACHINE_VNC_CACHED_SESSION_REQUEST =
  'CHECK_MACHINE_VNC_CACHED_SESSION_REQUEST';
export const CHECK_MACHINE_VNC_CACHED_SESSION_SUCCESS =
  'CHECK_MACHINE_VNC_CACHED_SESSION_SUCCESS';
export const CHECK_MACHINE_VNC_CACHED_SESSION_FAIL =
  'CHECK_MACHINE_VNC_CACHED_SESSION_FAIL';
export const CHECK_MACHINE_VNC_CACHED_SESSION_RESET_STATE =
  'CHECK_MACHINE_VNC_CACHED_SESSION_RESET_STATE';

export const SHOW_MACHINE_VNC_SESSION_EXPIRATION_MODAL =
  'SHOW_MACHINE_VNC_SESSION_EXPIRATION_MODAL';
export const HIDE_MACHINE_VNC_SESSION_EXPIRATION_MODAL =
  'HIDE_MACHINE_VNC_SESSION_EXPIRATION_MODAL';

export const OPEN = 'OPEN';
export const CLOSE = 'CLOSE';
export const EXPAND = 'EXPAND';
export const UNEXPAND = 'UNEXPAND';
export const MINIMIZE = 'MINIMIZE';
export const UNMINIMIZE = 'UNMINIMIZE';
export const RESET_VNC_UI = 'RESET_VNC_UI';
export const CACHED_OPEN = 'CACHED_OPEN';

export const SHOW_MACHINE_VNC_SESSION_CHECK_ONE_ALREADY_RUN_MODAL =
  'SHOW_MACHINE_VNC_SESSION_CHECK_ONE_ALREADY_RUN_MODAL';
export const HIDE_MACHINE_VNC_SESSION_CHECK_ONE_ALREADY_RUN_MODAL =
  'HIDE_MACHINE_VNC_SESSION_CHECK_ONE_ALREADY_RUN_MODAL';
